import { useApiClient } from '@/composables/useApiClient'
import type {
  ISignInRequest,
  ISignInResponse,
  IGenerateOtpRequest,
  IVerifyOtpRequest,
  IOtpResponse,
  IRegisterQueueRequest,
  IRegisterWhatsappRequest,
  ISessionStatusResponse,
  IForgotPasswordRequest,
  IVerifyResetTokenRequest,
  IResetPasswordRequest,
  IPasswordRecoveryResponse,
} from './interfaces'

const useAuthService = () => {
  const publicApi = useApiClient(false)
  // const privateApi = useApiClient(true)

  const login = async (credentials: ISignInRequest): Promise<ISignInResponse> => {
    return publicApi.post<ISignInResponse>('/oper/auth/login', credentials)
  }

  const generateOtp = async (dto: IGenerateOtpRequest): Promise<IOtpResponse> => {
    return publicApi.post<IOtpResponse>('/oper/auth/generate-otp', dto)
  }

  const verifyOtp = async (dto: IVerifyOtpRequest): Promise<IOtpResponse> => {
    return publicApi.post<IOtpResponse>('/oper/auth/verify-otp', dto)
  }

  const logout = async (username: string): Promise<boolean> => {
    return publicApi.post<boolean>(`/oper/auth/logout?username=${username}`)
  }

  const registerQueues = async (dto: IRegisterQueueRequest): Promise<boolean> => {
    return publicApi.post<boolean>('/oper/call/register-queue', dto)
  }

  const registerWhatsapp = async (dto: IRegisterWhatsappRequest): Promise<boolean> => {
    return publicApi.post<boolean>('/oper/whatsapp/campaign-login/register', dto)
  }

  const unregisterQueues = async (dto: IRegisterQueueRequest): Promise<boolean> => {
    return publicApi.post<boolean>('/oper/call/unregister-queue', dto)
  }

  const sessionStatus = async (emailOrUsername: string): Promise<ISessionStatusResponse> => {
    return publicApi.get<ISessionStatusResponse>(
      `/oper/auth/session-status/${encodeURIComponent(emailOrUsername)}`,
    )
  }

  const forgotPassword = async (
    dto: IForgotPasswordRequest,
  ): Promise<IPasswordRecoveryResponse> => {
    return publicApi.post<IPasswordRecoveryResponse>('/auth/forgot-password', dto)
  }

  const verifyResetToken = async (
    dto: IVerifyResetTokenRequest,
  ): Promise<IPasswordRecoveryResponse> => {
    return publicApi.post<IPasswordRecoveryResponse>('/auth/verify-reset-token', dto)
  }

  const resetPassword = async (dto: IResetPasswordRequest): Promise<IPasswordRecoveryResponse> => {
    return publicApi.post<IPasswordRecoveryResponse>('/auth/reset-password', dto)
  }

  return {
    login,
    generateOtp,
    verifyOtp,
    logout,
    registerQueues,
    registerWhatsapp,
    unregisterQueues,
    sessionStatus,
    forgotPassword,
    verifyResetToken,
    resetPassword,
  }
}

export { useAuthService }
